/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getStorage } from 'src/core/utils/getStorage';
import { DocumentStorage } from 'src/customText/core/utils/documentStorage/types';

/**
 * Gets a local storage implementation of document. This implementation
 * persists documents in either local storage or session storage based
 * on the passed config.
 */
export const getBrowserLocalDocumentStorage = (config: {
    containerId: string;
    storageType: Parameters<typeof getStorage>[0];
}): DocumentStorage => {
    const storage = getStorage(config.storageType);

    const createKey = (documentId: string) => `${config.containerId}/${documentId}`;

    return {
        getDocument: documentId => storage.getData(createKey(documentId)),
        clearStorage: () => storage.clear(),
        getCount: () => storage.getSize(),
        hasDocument: documentId => storage.hasData(createKey(documentId)),
        removeDocument: documentId => storage.removeData(createKey(documentId)),
        setDocument: (documentId, content) => storage.setData(createKey(documentId), content)
    };
};
